import {
  runNewsroomInit,
  AVAILABLE_TAGS,
} from '../common/newsroom-hub/newsroom-hub';

runNewsroomInit(AVAILABLE_TAGS.PRO_INSTALLERS);
